<template>
  <div></div>
</template>

<script>
export default {
  name: "SinglePageToHomeRedirect",
  mounted() {
    let app = this
    app.redirectToHome();
  },
  methods: {
    redirectToHome() {
      let app = this
      window.localStorage.removeItem('tempId');
      window.localStorage.removeItem('cartCount');
      app.$router.push({name: 'main'})
      app.$bus.$emit('restLandingFilter');
      app.$bus.$emit('resetCartInfo');
      location.reload();
    }
  }
}
</script>

<style scoped>

</style>